import { IDealsFilter } from 'modules/settings/submodules/clients/deals/store/models';
import { createSingleAction } from 'store/utils';

export const SET_DEAL_FILTER = 'settings/SET_DEAL_FILTER';
export const setDealFilter = createSingleAction<IDealsFilter, typeof SET_DEAL_FILTER>(
    SET_DEAL_FILTER,
);
